export default __webpack_public_path__ + "static/media/promo-perorangan.f6280a34.png";